import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOnline: true,
  lastChangeAt: null,
  queuedWriteCount: 0,
  queuedMediaCount: 0,
};

const connectivitySlice = createSlice({
  name: "connectivity",
  initialState,
  reducers: {
    setOnlineStatus(state, action) {
      const nextStatus = Boolean(action.payload?.isOnline);
      if (state.isOnline !== nextStatus) {
        state.lastChangeAt = Date.now();
      }
      state.isOnline = nextStatus;
    },
    setQueuedWriteCount(state, action) {
      state.queuedWriteCount = Number(action.payload?.count || 0);
    },
    setQueuedMediaCount(state, action) {
      state.queuedMediaCount = Number(action.payload?.count || 0);
    },
  },
});

export const connectivityActions = connectivitySlice.actions;
export default connectivitySlice;
